import { render } from "./CIS-ResourceBlogData.vue?vue&type=template&id=7ea28ee4"
import script from "./CIS-ResourceBlogData.vue?vue&type=script&lang=js"
export * from "./CIS-ResourceBlogData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__